// TSS vite/02 — centralized constants.
// Storage keys live here so a rename happens in one place.

export const STORAGE_KEYS = {
    LOGOUT_SIGNAL: 'logout_signal',
    UI_PREFS:      'ui_prefs',
};

// sessionStorage, not localStorage: the demo's inventory and results are
// per-session by design ("5.500 números tomados en cada sesión"). Closing the
// tab is meant to reset the simulation.
export const SESSION_KEYS = {
    LOTTERY_SEED:   'rapichontico_seed',
    LOTTERY_TICKETS: 'rapichontico_tickets',
    LOTTERY_SLOT_OFFSET: 'rapichontico_slot_offset',
};
